import React, { useMemo } from 'react';
import { Tabs, Progress } from 'antd';
import questionsTheme from './questionsTheme';

// Hardcoded descriptions mapped from the legacy UI
const QUIZ_DESCRIPTIONS = {
    1: "This quiz checks your understanding of the basic skills and concepts covered in this topic, as well as containing a couple of problem-solving questions.",
    2: "The questions in this quiz may require you to use a pencil and paper. In addition to utilising skills and concepts covered in this topic, you will need to use your problem-solving skills for some questions.",
    3: "The questions in this quiz will require you to think outside the square, bringing in skills from other topics. Use your problem-solving and reasoning skills to analyse the question and find a solution."
};

const QuizSelector = ({ levelsData, conceptName, selectedLevel, showQuestions, onSelectLevel, onStartQuiz }) => {

    const tabItems = useMemo(() => {
        if (!levelsData) return [];

        return levelsData.map((levelObj) => ({
            key: String(levelObj.value),
            label: levelObj.description,
            disabled: levelObj.questionCount === 0
        }));
    }, [levelsData]);

    const handleTabChange = (activeKey) => {
        const selected = levelsData.find(l => String(l.value) === activeKey);
        if (selected) {
            onSelectLevel(selected);
        }
    };

    // Safely extract stats for the progress circle
    const attemptCount = selectedLevel?.attemptCount || 0;
    const correctCount = selectedLevel?.correctCount || 0;
    const questionCount = selectedLevel?.questionCount || 0;

    // Fallback description if the level value doesn't match 1, 2, or 3
    const descriptionText = selectedLevel
        ? (QUIZ_DESCRIPTIONS[selectedLevel.value] || `Test your understanding of: ${conceptName || 'this topic'}`)
        : '';

    return (
        <>
            {levelsData && levelsData.length > 0 && (
                <Tabs
                    className="ch-tabs-lvl2 margin-b--m"
                    items={tabItems}
                    activeKey={selectedLevel ? String(selectedLevel.value) : undefined}
                    onChange={handleTabChange}
                />
            )}

            {selectedLevel && !showQuestions && (
                <div className="ch-card ch-surface-bg margin-b--m padding--m flexRow flexSpaceBetween flexAlignCentre">
                    <div style={{ flex: 1, paddingRight: '24px' }}>
                        <h3 className="ch-h3 margin-b--s">{selectedLevel.description}</h3>
                        <p className="margin-b--m">{descriptionText}</p>

                        <div className="flexRow flexAlignCentre smallGap margin-b--m">
                            <span
                                style={{
                                    display: 'inline-block',
                                    backgroundColor: questionsTheme.lightTeal,
                                    padding: '4px 12px',
                                    borderRadius: '16px',
                                    fontWeight: 'bold',
                                }}
                            >
                                {questionCount} Questions
                            </span>
                            <span>
                                available in this quiz
                            </span>
                        </div>

                        <button
                            onClick={onStartQuiz}
                            className="ch-button ch-btn-medium"
                            style={{ backgroundColor: questionsTheme.primaryOrange, color: '#fff' }}
                        >
                            Start Quiz
                        </button>
                    </div>

                    {/* Reintroduced Progress Circle */}
                    {questionCount > 0 && (
                        <div className="margin-l--l">
                            <Progress
                                className="ch-pq-progress"
                                percent={(attemptCount / questionCount) * 100}
                                success={{ percent: (correctCount / questionCount) * 100 }}
                                type="circle"
                                size={60}
                                strokeWidth={16}
                                strokeLinecap="butt"
                                format={() => (
                                    <span aria-label={`${correctCount} correct out of ${attemptCount} attempts`}></span>
                                )}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default QuizSelector;